import { action, computed, makeObservable, observable } from 'mobx';
import { taskService } from 'config/ioc';
import { FULFILLED, PENDING, REJECTED } from 'constants/actions';
import routerStore from './RouterStore';
import taskListStore from './TaskListStore';

class TaskStore {
  fetchState;

  updateTaskState;

  task;

  constructor() {
    makeObservable(this, {
      fetchState: observable,
      updateTaskState: observable,
      task: observable.ref,
      getTask: action,
      updateTask: action,
      completeTask: action,
      closeTask: action,
      reopenTask: action,
      deleteTask: action,
      initialFormValues: computed,
    });
  }

  get initialFormValues() {
    return {
      name: this.task.content,
      type: this.task.type,
      assignee: this.task.assignees,
      customer: this.task.customer,
      construction: this.task.construction,
      dueDate: this.task.due ? new Date(this.task.due) : null,
      priority: this.task.priority,
    };
  }

  async getTask(taskId) {
    this.fetchState = PENDING;
    try {
      const response = await taskService.getTask(taskId);
      const [task] = response.data.data.items;
      this.task = task;
      this.fetchState = FULFILLED;
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }

  async updateTask(taskId, data) {
    this.fetchState = PENDING;

    try {
      await taskService.updateTask(taskId, data);
      this.fetchState = FULFILLED;
      this.getTask(taskId);
      taskListStore.setRefreshTask(true);
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }

  async completeTask(taskId, resultTask) {
    this.fetchState = PENDING;

    try {
      await taskService.completeTask(taskId, resultTask);
      this.fetchState = FULFILLED;
      this.getTask(taskId);
      taskListStore.setRefreshTask(true);
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }

  async closeTask(taskId) {
    this.fetchState = PENDING;

    try {
      await taskService.closeTask(taskId);
      this.fetchState = FULFILLED;
      this.getTask(taskId);
      taskListStore.setRefreshTask(true);
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }

  async reopenTask(taskId) {
    this.fetchState = PENDING;

    try {
      await taskService.reopenTask(taskId);
      this.fetchState = FULFILLED;
      this.getTask(taskId);
      taskListStore.setRefreshTask(true);
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }

  async deleteTask(taskId) {
    this.fetchState = PENDING;

    try {
      await taskService.deleteTask(taskId);
      this.fetchState = FULFILLED;
      taskListStore.setRefreshTask(true);
      routerStore.push('/organizer');
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }
}

const taskStore = new TaskStore();

export default taskStore;
